// extracted by mini-css-extract-plugin
export default {"table":"ArchivedActivityTable_table__pRJ4Z","sucessful-state":"ArchivedActivityTable_sucessful-state__N3hy5","cancelled-state":"ArchivedActivityTable_cancelled-state__8xSbu"};